import GenericPage from './GenericPage'

export default GenericPage
